module.exports = __webpack_public_path__ + "static/media/LogoLandPage.6cba3c6f.png";